<template>
  <v-flex>
    <v-form ref="form">
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="name"
              label="Startup Name"
              :rules="rules.name"
              required
              :counter="50"
              @input="$v.name.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="country"
              :items="countries"
              label="Country"
              menu-props="auto, overflowY"
              required
              item-text="country"
              item-value="country"
              return-object
              :error-messages="countryErrors"
              @change="$v.country.$touch()"
              @blur="$v.country.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-if="country === 'Italy'" class="pa-3">
          <v-select
              v-model="region"
              :items="regions"
              label="Region"
              :error-messages="regionErrors"
              menu-props="auto, overflowY"
              required
              item-text="region"
              item-value="region"
              return-object
              @change="$v.region.$touch()"
              @blur="$v.region.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-else class="pa-3">
          <v-text-field
              v-model="city"
              label="City"
              required
              :rules="rules.city"
              :counter="100"
              @input="$v.city.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="area"
              :items="Object.keys(areas)"
              label="Area"
              :error-messages="areaErrors"
              @change="$v.area.$touch()"
              @blur="$v.area.$touch()"
              class="text_wrapper"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="verticalSolution"
              :items="areas[area]"
              :error-messages="verticalErrors"
              label="Vertical solution"
              @change="$v.verticalSolution.$touch()"
              @blur="$v.verticalSolution.$touch()"
              class="text_wrapper"
              no-data-text="No data available. First select the area"
          >
            <template v-slot:prepend-item>
              <v-list-tile
                  v-if="areas[area] !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                  ripple
                  @click="enableNewVertical = true"
              >
                <v-list-tile-action>
                  <v-icon>mdi-plus</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Add new vertical</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="areas[area] !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                         class="mt-2"></v-divider>
            </template>

            <template slot="item" slot-scope="data">
              {{ data.item }}
              <v-spacer></v-spacer>
              <v-icon v-if="startupId !== '' && userInfo.role==='APPROVER_INNOVATION'" color="red"
                      @click.stop="openDeleteVertical(data.item)">mdi-delete
              </v-icon>
            </template>

          </v-select>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="ideaState"
              :items="ideaStates"
              label="Idea State"
              menu-props="auto, overflowY"
              item-text="ideaState"
              item-value="ideaState"
              :error-messages="ideaErrors"
              return-object
              @change="$v.ideaState.$touch()"
              @blur="$v.ideaState.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="contactName"
              label="Contact Name"
              :counter="100"
              :rules="rules.contactName"
              @input="$v.contactName.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="contactDetails"
              label="Email Addresses (separate emails by , or ; or / )"
              :rules="rules.email"
              :counter="500"
              @input="$v.contactDetails.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="patent"
              :items="patents"
              label="Patents available"
              menu-props="auto, overflowY"
              :error-messages="patentErrors"
              item-text="patent"
              item-value="patent"
              return-object
              @change="$v.patent.$touch()"
              @blur="$v.patent.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="sdk"
              :items="sdks"
              label="SDK/API available"
              menu-props="auto, overflowY"
              item-text="sdk"
              item-value="sdk"
              :error-messages="sdkErrors"
              return-object
              @change="$v.sdk.$touch()"
              @blur="$v.sdk.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="existing_partnership"
              :items="existing_partnerships"
              label="Existing Partnerships/Exclusivity (non-VC's)"
              menu-props="auto, overflowY"
              item-text="existing_partnership"
              item-value="existing_partnership"
              :error-messages="existing_partnership_Errors"
              return-object
              @change="$v.existing_partnership.$touch()"
              @blur="$v.existing_partnership.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-select
              v-model="businessModel"
              :items="businessModels"
              label="Business Model"
              menu-props="auto, overflowY"
              item-text="businessModel"
              :error-messages="businessErrors"
              item-value="businessModel"
              return-object
              @change="$v.businessModel.$touch()"
              @blur="$v.businessModel.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="website"
              label="Website"
              :rules="rules.website"
              :counter="500"
              @input="$v.website.$touch()"
              @blur="$v.website.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-combobox
              v-model="Tags"
              :items="tagsSuggestions"
              label="Tags (separate each tag clicking Enter)"
              multiple
              :rules="rules.tags"
              hide-selected
              chips
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <span>{{ data.item }}</span>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="startupId !== '' && userInfo.role==='APPROVER_INNOVATION'" color="red"
                        @click.stop="openDeleteTag(data.item)">mdi-delete
                </v-icon>
              </v-list-tile-action>

            </template>


          </v-combobox>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                  v-model="mobilePhone"
                  label="Mobile Phone"
                  :rules="rules.mobilePhone"
                  :counter="100"
                  @input="$v.mobilePhone.$touch()"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="contactLinks"
              label="Company LinkedIn URL"
              :rules="rules.contactLinks"
              :counter="500"
              @input="$v.contactLinks.$touch()"
              @blur="$v.contactLinks.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="contactAddress"
              label="Contact Address"
              :counter="200"
              :rules="rules.contactAddress"
              @input="$v.contactAddress.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="logo"
              label="Logo"
              :counter="500"
              :rules="rules.logo"
              @input="$v.logo.$touch()"
              @blur="$v.logo.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="crunchbaseLink"
              label="Crunchbase link"
              :counter="500"
              :rules="rules.crunchbaseLink"
              @input="$v.crunchbaseLink.$touch()"
              @blur="$v.crunchbaseLink.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="fundingsAmount"
              label="Fundings Amount"
              :counter="200"
              :rules="rules.fundingsAmount"
              @input="$v.fundingsAmount.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="fundingsDate"
              label="Fundings Date"
              :rules="rules.fundingsDate"
              :counter="100"
              @input="$v.fundingsDate.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="fundingsInvestors"
              label="Fundings Investors"
              :counter="200"
              :rules="rules.fundingsInvestors"
              @input="$v.fundingsInvestors.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="Valuation"
              label="Valuation"
              :counter="500"
              :rules="rules.Valuation"
              @input="$v.Valuation.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="Competitors"
              label="Competitors"
              :counter="500"
              :rules="rules.Competitors"
              @input="$v.Competitors.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="foundation"
              label="Foundation"
              :rules="rules.foundation"
              :counter="100"
              @input="$v.foundation.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="numberEmployees"
              label="Number Employees"
              type="number"
              min="0"
              step="1"
              @input="$v.numberEmployees.$touch()"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 class="pa-3">
          <v-text-field
              v-model="urlVideo"
              label="URL Video"
              :rules="rules.urlVideo"
              :counter="500"
              @input="$v.urlVideo.$touch()"
              @blur="$v.urlVideo.$touch()"
          />
        </v-flex>
      </v-layout>
      <v-layout align-center
                row
                spacer>
        <v-flex xs2 sm1 md1>
          <v-avatar>
            <img :src="require('@/assets/img/settings/flags/en.png')">
          </v-avatar>
        </v-flex>
        <v-flex xs10 sm5 md5 class="pa-3">

          <v-textarea
              v-model="englishDescription"
              auto-grow
              box
              :counter="3000"
              :rules="rules.description"
              name="englishDescription"
              label="English idea description"
              border-radius="20px"
              value=""
              rows="2"
          />
        </v-flex>
        <v-flex xs2 sm1 md1 v-if="country === 'Italy' || startupId !== ''">
          <v-avatar>
            <img :src="require('@/assets/img/settings/flags/it.png')">
          </v-avatar>
        </v-flex>
        <v-flex xs10 sm5 md5 v-if="country === 'Italy' || startupId !== ''">
          <v-textarea
              v-model="italianDescription"
              auto-grow
              box
              :counter="3000"
              :rules="rules.description"
              name="italianDescription"
              label="Italian idea description"
              border-radius="20px"
              value=""
              rows="2"
          />
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="registrationStatus" max-width="450">
      <v-card v-if="!registrationError">
        <v-card-title class="headline success white--text">Registration successfully completed</v-card-title>
        <v-card-text>Your registration will be evaluated as soon as possible.</v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline error white--text">Registration failed</v-card-title>
        <v-card-text>Something went wrong... Retry!</v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="verticalError" max-width="450">
      <v-card>
        <v-card-title class="headline error white--text">Vertical creation failed</v-card-title>
        <v-card-text>{{ verticalErrorDescription }}</v-card-text>
      </v-card>
    </v-dialog>

    <!-- NEW VERTICAL DIALOG-->
    <v-dialog
        v-model="enableNewVertical"
        max-width="650"
        persistent
    >
      <v-card>
        <v-card-title class="headline" style="word-break: break-word">
          Add new vertical to area {{ area }}
        </v-card-title>

        <v-card-text>
          Which vertical do wou want to add?
          <v-text-field
              v-model="newVertical"
              regular
              :rules="rules.vertical"
              autofocus
              color="deep-purple"
              label="New vertical"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              round
              color="green"
              flat
              @click="addVertical()"
          >
            Confirm
          </v-btn>
          <v-btn
              round
              color="red"
              flat
              @click="closeNewVertical"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE VERTICAL DIALOG-->
    <v-dialog
        v-model="dialogDeleteConfirm"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Deletion vertical confirmation</span>
        </v-card-title>

        <v-card-text>
          <v-flex>
            <span class="subheading">Are you sure you want to delete the vertical '{{ verticalToDelete }}'?</span>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
              round
              color="red"
              flat
              @click="dialogDeleteConfirm=false"
          >
            NO
          </v-btn>
          <v-btn
              round
              color="green"
              flat
              @click="deleteVertical"
          >
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE TAG DIALOG-->
    <v-dialog
        v-model="dialogTagConfirm"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Deletion tag confirmation</span>
        </v-card-title>

        <v-card-text>
          <v-flex>
            <span class="subheading">Are you sure you want to delete the tag '{{ tagToDelete }}'?</span>
            <br>
            <span
                class="subheading">Remember that the tag will be removed from the following startups: {{
                startupString
              }}.</span>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
              round
              color="red"
              flat
              @click="dialogTagConfirm=false"
          >
            NO
          </v-btn>
          <v-btn
              round
              color="green"
              flat
              @click="deleteTag"
          >
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>


</template>

<script>
import {validationMixin,} from "vuelidate";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import countryList from "country-list"
import countryTelData from "country-telephone-data"
import {email, maxLength, minLength, required,} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";


export default {
  name: "FormStartupRegistration",
  components: {},
  mixins: [validationMixin,],
  props: ["startupId"],
  validations: {
    name: {required, minLength: minLength(3), maxLength: maxLength(50),},
    country: {required},
    city: {required},
    region: {required},
    contactName: {required},
    contactDetails: {email, required},
    logo: {required},
    fundingsDate: {required},
    area: {required},
    verticalSolution: {required},
    ideaState: {required},
    patent: {required},
    sdk: {required},
    businessModel: {required},
    website: {},
    contactAddress: {},
    fundingsInvestors: {},
    fundingsAmount: {},
    foundation: {},
    numberEmployees: {},
    contactLinks: {},
    tags: {},
    mobilePhone: {},
    crunchbaseLink: {},
    urlVideo: {},
    existing_partnership: {}
  },
  data: () => ({
    startupString: "",
    verticalError: false,
    verticalErrorDescription: "",
    verticalToDelete: "",
    dialogDeleteConfirm: false,
    tagToDelete: "",
    dialogTagConfirm: false,
    newVertical: "",
    enableNewVertical: false,
    registrationStatus: false,
    registrationError: false,
    startup: {},
    rules: {
      required: value => !!value || 'Required',
      name: [
        value => !!value || 'Required',
        value => {
          const pattern = /(http:\/\/|https:\/\/|www.)+/gm
          return value === '' || !pattern.test(value) || 'Invalid name'
        },
        v => v.length <= 50 || 'Startup name must be less than 50 characters',
        v => v.length >= 3 || 'Startup name must be at least 3 characters'],
      city: [v => v.length <= 100 || 'City must be less than 100 characters', v => v == '', value => {
        const pattern = /[^\w.,;'\/ -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      description: [v => v.length <= 3000 || 'Description must be less than 3000 characters'],
      contactName: [v => v.length <= 100 || 'Contact name must be less than 100 characters', value => {
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      email: [value => !!value || 'Required',
        value => {
          //const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const pattern = /^([\w+\-.%]+@[\w-.]+\.[A-Za-z]+)([,;/] ?[\w+\-.%]+@[\w-.]+\.[A-Za-z]+)*$/g
          // versione con negative look ahead e negative look behind si prende il punto inziale per le mail intermedie
          // const pattern = /^(\w+\b(?<!\.))(\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^£$%&+=*'<>()[\]\\,;:\s@"](\w+\b(?!\.))+\s?[,;\/])*(\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^£$%&+=*'<>()[\]\\,;:\s@"]+)(\w+\b(?!\.))$/g
          // const pattern = /^((\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^\.?£$%&+=*'<>)[\]\\,;:\s@"]+)([,;\/]))*(\s?[^£$%&+=*'<>()[\]\\,;:\s@"]+@[^£$%&+=*'<>()[\]\\,;:\s@"]+\.[^\.?£$%&+=*'<>()[\]\\,;:\s@"]+)$/g
          return value === '' || pattern.test(value) || 'Invalid e-mail'
        },
        v => v.length <= 500 || 'Email address must be less than 500 characters',
        v => v.length >= 5 || 'Email addres must be at least 5 characters'],
      website: [value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid website'
      },
        v => v.length <= 500 || 'Website must be less than 500 characters'],
      mobilePhone: [value => {
        const pattern = /^([+]*[(]?[+]?[0-9]{1,4}[)]?[-\s.0-9]*)( ?[,;] ?[+]*[(]?[+]?[0-9]{1,4}[)]?[-\s.0-9]+)*$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid mobile phone numbers'
      }, v => v.length <= 100 || 'Mobile phone must be less than 100 characters'],
      contactLinks: [value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid contact links'
      },
        v => v.length <= 500 || 'Contact links must be less than 500 characters'],
      fundingsDate: [v => v.length <= 100 || 'Funding investors must be less than 100 characters', value => {
        // const pattern = /^[a-zA-Z0-9_.,;\/-]+( *[a-zA-Z0-9_.,;\/-]+)*$/gm
        const pattern = /[^\w.,;\/ -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      foundation: [v => v.length <= 100 || 'Foundation must be less than 100 characters', value => {
        // const pattern = /^[a-zA-Z0-9_.,;\/-]+( *[a-zA-Z0-9_.,;\/-]+)*$/gm
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      contactAddress: [v => v.length <= 200 || 'Contact address must be less than 200 characters', value => {
        // const pattern = /^[a-zA-Z0-9_.,;-]+( *[a-zA-Z0-9_.,;-]+)*$/gm
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      logo: [value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid logo url'
      }, v => v.length <= 500 || 'Logo link must be less than 500 characters'],
      crunchbaseLink: [value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid crunchbase url'
      }, v => v.length <= 500 || 'Crunchbase url must be less than 500 characters'],
      fundingsInvestors: [v => v.length <= 200 || 'Funding investors must be less than 200 characters', value => {
        // const pattern = /^[a-zA-Z0-9_.$£€,\s-]+( *[a-zA-Z0-9_.$£€,\s-]+)*$/gm
        const pattern = /[^\w.;$£€'àèéìòù,\s -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      fundingsAmount: [v => v.length <= 200 || 'Funding amount must be less than 200 characters', value => {
        // const pattern = /^[a-zA-Z0-9_.$£€,\s-]+( *[a-zA-Z0-9_.$£€,\s-]+)*$/gm
        const pattern = /[^\w.;$£€'àèéìòù,\s -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      vertical: [v => v.length <= 200 || 'Vertical must be less than 200 characters', value => {
        const pattern = /[^\w.,;'\/()&àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      tags: [value => {
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      urlVideo: [value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid URL video'
      },v => v.length <= 500 || 'URL video must be less than 500 characters']
    },
    urlVideo: "",
    telephonePrefix: "",
    telephonePrefixArray: [],
    name: "",
    country: "",
    countries: [],
    tagsSuggestions: [],
    Tags: [],
    mobilePhone: "",
    contactLinks: "",
    contactAddress: "",
    fundingsAmount: "0.0",
    logo: "",
    crunchbaseLink: "",
    fundingsDate: "",
    fundingsInvestors: "",
    foundation: "",
    numberEmployees: "",
    regions: ["Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia Romagna", "Friuli Venezia Giulia", "Lazio",
      "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia", "Sardegna",
      "Sicilia", "Toscana", "Trentino Alto Adige", "Umbria",
      "Valle d'Aosta", "Veneto"],
    region: "",
    city: "",
    forceRecomputeCounter: 0,
    contactName: "",
    contactDetails: "",
    verticalSolution: "",
    area: "",
    ideaState: "",
    ideaStates: ["Idea", "Prototype/beta version",/*"Ready",*/"Product", "On the market", "First customers"],
    areas: {},
    patent: "",
    patents: ["Yes", "No", "Pending"],
    sdk: "",
    sdks: ["Yes", "No"],
    existing_partnership: "",
    existing_partnerships: ["Yes", "No"],
    businessModel: "",
    businessModels: ["B2B", "B2B:B2C", "B2C"],
    website: "",
    englishDescription: "",
    italianDescription: "",
    Valuation: "",
    Competitors: "",
    scoreMap: {
      "Idea state": {
        "First customers": 4,
        "Idea": 0,
        "On the market": 3,
        "Product": 3,
        "Prototype/beta version": 1,
        //"Ready": 2,
        "-": 0,
        "": 0
      },
      "Patent": {
        "y": 1,
        "n": 0,
        "-": 0,
        "": 0,
        "pending": 0.5
      },
      "SDK/API": {
        "y": 1,
        "n": 0,
        "-": 0,
        "": 0
      },
      "Existing Partnerships/Exclusivity (non-VC's)" : {
        "y": 1,
        "n": 0,
        "-": 0,
        "": 0
      },
      "Business model": {
        "B2B": 2,
        "B2B:B2C": 1,
        "B2C": 0,
        "-": 0,
        "": 0
      },
    },
  }),
  computed: {
    ...mapGetters("UserState", {
          userInfo: "getUserInfo",
        }
    ),
    countryErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.country, this.countries)) {
        let error = "Value " + this.checkValidItem(this.country, this.countries) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.country = this.checkValidItem(this.country, this.countries)
      }

      return errors;
    },
    regionErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.region, this.regions)) {
        let error = "Value " + this.checkValidItem(this.region, this.regions) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.region = this.checkValidItem(this.region, this.regions)
      }

      return errors;
    },
    areaErrors() {
      const errors = [];
      this.forceRecomputeCounter;
      if (Object.keys(this.areas).length > 0) {
        if (!this.checkValidItemBoolean(this.area, Object.keys(this.areas))) {
          let error = "Value " + this.checkValidItem(this.area, Object.keys(this.areas)) + " saved in DB is not valid!"
          errors.push(error)
        } else {
          this.area = this.checkValidItem(this.area, Object.keys(this.areas))
        }
      }
      return errors;
    },
    verticalErrors() {
      const errors = [];
      if (this.areas[this.area] !== undefined) {
        if (!this.checkValidItemBoolean(this.verticalSolution, this.areas[this.area])) {
          let error = "Value " + this.checkValidItem(this.verticalSolution, this.areas[this.area]) + " saved in DB is not valid!"
          errors.push(error)
        } else {
          this.verticalSolution = this.checkValidItem(this.verticalSolution, this.areas[this.area])
        }
      }
      return errors;
    },
    ideaErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.ideaState, this.ideaStates)) {
        let error = "Value " + this.checkValidItem(this.ideaState, this.ideaStates) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.ideaState = this.checkValidItem(this.ideaState, this.ideaStates)
      }

      return errors;
    },
    patentErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.patent, this.patents)) {
        let error = "Value " + this.checkValidItem(this.patent, this.patents) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.patent = this.checkValidItem(this.patent, this.patents)
      }

      return errors;
    },
    sdkErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.sdk, this.sdks)) {
        let error = "Value " + this.checkValidItem(this.sdk, this.sdks) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.sdk = this.checkValidItem(this.sdk, this.sdks)
      }

      return errors;
    },
    existing_partnership_Errors(){
      const errors = [];
      if (!this.checkValidItemBoolean(this.existing_partnership, this.existing_partnerships)) {
        let error = "Value " + this.checkValidItem(this.existing_partnership, this.existing_partnerships) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.existing_partnership = this.checkValidItem(this.existing_partnership, this.existing_partnerships)
      }

      return errors;
    },
    businessErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.businessModel, this.businessModels)) {
        let error = "Value " + this.checkValidItem(this.businessModel, this.businessModels) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.businessModel = this.checkValidItem(this.businessModel, this.businessModels)
      }

      return errors;
    },
    startupComputed() {
      let startup = {
        "Area": this.area,
        "Name": this.name,
        "Country": this.country,
        "Region / city": this.country === 'Italy' ? this.region : this.city,
        "Contact name": this.contactName,
        "Contact details": this.contactDetails,
        "Idea description-EN": this.englishDescription,
        "Idea description-IT": this.italianDescription,
        "Vertical solution (if any)": this.verticalSolution,
        "Idea state": this.ideaState,
        "Patent": this.convertParameter(this.patent),
        "SDK/API": this.convertParameter(this.sdk),
        "Existing Partnerships/Exclusivity (non-VC's)" : this.convertParameter(this.existing_partnership),
        "Business model": this.businessModel,
        "Website": this.website,
        "Tags": this.Tags,
        "Mobile phone": this.mobilePhone,
        "Contact links": this.contactLinks,
        "Contact address": this.contactAddress,
        "Fundings amount": this.fundingsAmount,
        "Logo": this.logo,
        "Crunchbase link": this.crunchbaseLink,
        "Fundings date": this.fundingsDate,
        "Fundings investors": this.fundingsInvestors,
        "Valuation": this.Valuation,
        "Competitors": this.Competitors,
        "Foundation": this.foundation,
        "NumberEmployees": this.numberEmployees,
        "UrlVideo": this.urlVideo,
        "approved": 0
      };
      return startup;
    }
  },
  watch: {
    startupComputed(newStartup) {
      let score = 0;
      for (let key in this.scoreMap) {
        score = score + this.scoreMap[key][newStartup[key]];
      }
      this.$emit('update', score)
      return score;
    }
  },


  created() {
    for (let i = 0; i < countryTelData.allCountries.length; i++) {
      let object = {
        prefix: "+" + countryTelData.allCountries[i].dialCode,
        toShow: countryTelData.allCountries[i].iso2.toUpperCase() + "   +" + countryTelData.allCountries[i].dialCode
      }
      this.telephonePrefixArray.push(object);
    }
    if (this.startupId !== "" && this.startupId !== "newStartup") {
      this.getStartup(this.startupId);
    }

    this.countries = countryList.getNames().sort();
    this.getTagsSuggestion();
  },
  methods: {
    checkValidItemBoolean(item, items) {
      for (let i = 0; i < items.length; i++) {
        if (item === undefined || items === undefined || item === "" || item === "-") return true;
        if (item.toLowerCase() === items[i].toLowerCase()) {
          item = items[i];
          return true;
        }
      }
      return false;
    },
    checkValidItem(item, items) {
      for (let i = 0; i < items.length; i++) {
        if (item.toLowerCase() === items[i].toLowerCase()) {
          item = items[i];
          break;
        }
      }
      return item;
    },
    openDeleteVertical(item) {
      this.dialogDeleteConfirm = true;
      this.verticalToDelete = item;
    },
    openDeleteTag(item) {
      let requestUrl = {
        url: UrlsService.tagsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "FIND_MATCH",
          tagRequest: {
            tag: item,
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Find startups with tag",
        error: "Error search...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let startups = responseSuccess.response.startups;
            this.startupString = startups.map(function (elem) {
              return elem["Name"];
            }).join(", ");
            this.dialogTagConfirm = true;
            this.tagToDelete = item;
          });

    },
    deleteTag() {
      this.dialogTagConfirm = false;
      let requestUrl = {
        url: UrlsService.tagsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "DELETE",
          tagRequest: {
            tag: this.tagToDelete
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Delete tag",
        error: "Error delete tag...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.getTagsSuggestion();
          });

    },
    sanitize(event, variableName) {
      event.preventDefault();
      this[variableName] = this.$sanitize(event.target.value)
    },
    closeNewVertical() {
      this.enableNewVertical = false;
      this.newVertical = "";
    },
    deleteVertical() {
      this.dialogDeleteConfirm = false;
      let requestUrl = {
        url: UrlsService.vertical,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "DELETE",
          verticalRequest: {
            area: this.area,
            vertical: this.verticalToDelete
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Delete vertical",
        error: "Error delete vertical...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewVertical = false;
            this.getTagsSuggestion();
          });

    },
    addVertical() {
      let requestUrl = {
        url: UrlsService.vertical,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "CREATE",
          verticalRequest: {
            area: this.area,
            vertical: this.newVertical
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Create new vertical",
        error: "Error create vertical...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewVertical = false;
            this.newVertical = "";
            if (responseSuccess.response !== undefined && responseSuccess.response.data.responseStatus.code === 501) {
              this.verticalError = true;
              this.verticalErrorDescription = responseSuccess.response.data.responseStatus.description
            } else {
              this.getTagsSuggestion();
            }

          });

    },
    getTagsSuggestion() {
      let requestUrl = {
        url: UrlsService.getTagsSuggestion,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "",
          elasticSearchRequest: {
            pageSize: 1000,
            pageNumber: 0
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List Tags Suggestion",
        error: "Error get suggestion...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.tagsSuggestions = [];
            let responseSearch = responseSuccess.response.searchResults;
            if (responseSearch != undefined) {
              for (let i = 0; i < responseSearch.length; i++) {
                if (responseSearch[i]["tags"] != undefined && responseSearch[i]["approved"] == 1) {
                  let tags = responseSearch[i]["tags"]
                  for (let j = 0; j < tags.length; j++) {
                    if (!this.tagsSuggestions.includes(tags[j]) && tags[j] != 'None') {
                      this.tagsSuggestions.push(tags[j])
                    }
                  }
                }
              }
            }

            let responseArea = responseSuccess.response.areas;
            if (responseArea !== undefined) {
              for (let i = 0; i < responseArea.length; i++) {
                this.areas[responseArea[i].area] = responseArea[i].verticals;
              }
              this.forceRecomputeCounter++;

            }


          });
    },
    getStartup(id) {
      let startup = {
        _id: id
      }
      let requestUrl = {
        url: UrlsService.getStartupById,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          startupRequest: {
            startup: startup
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Get Startup",
        loading: "Waiting for the startup information...",
        error: "Cannot get the startup...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.startup = responseSuccess.response.startups[0];
            for (let key in this.startup) {
              if (this.startup[key] === 'None') {
                this.startup[key] = "";
              }
            }
            this.name = this.startup["Name"];
            this.$emit('updateName', this.name)
            this.$emit('updateApproved', this.startup["approved"])
            this.country = this.startup["Country"];
            this.city = this.country === 'Italy' ? "" : this.startup["Region / city"];
            this.region = this.country === 'Italy' ? this.startup["Region / city"] : "";
            this.contactName = this.startup["Contact name"];
            this.contactDetails = this.startup["Contact details"];
            this.verticalSolution = this.startup["Vertical solution (if any)"];
            this.area = this.startup["Area"];
            this.ideaState = this.startup["Idea state"];
            this.patent = this.inverseConvertParameter(this.startup["Patent"]);
            this.sdk = this.inverseConvertParameter(this.startup["SDK/API"]);
            this.existing_partnership = this.inverseConvertParameter(this.startup["Existing Partnerships/Exclusivity (non-VC's)"])
            this.businessModel = this.startup["Business model"];
            this.website = this.startup["Website"];
            this.englishDescription = this.decodeHtml(this.startup["Idea description-EN"]);
            this.italianDescription = this.decodeHtml(this.startup["Idea description-IT"]);
            this.Tags = this.startup['Tags'];
            this.mobilePhone = this.startup['Mobile phone'];
            this.contactLinks = this.startup['Contact links'];
            this.contactAddress = this.startup["Contact address"];
            this.fundingsAmount = this.startup["Fundings amount"];
            this.logo = this.startup['Logo'];
            this.crunchbaseLink = this.startup['Crunchbase link'];
            this.fundingsDate = this.startup['Fundings date'];
            this.fundingsInvestors = this.startup['Fundings investors'];
            this.Valuation = this.startup['Valuation'];
            this.Competitors = this.startup['Competitors'];
            this.foundation = this.startup['Foundation'];
            this.numberEmployees = this.startup['NumberEmployees'];
            this.urlVideo = this.startup['UrlVideo'];
          });
    },
    formValidate() {
      this.$v.$touch();
      return this.$refs.form.validate();
    },
    decodeHtml(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    submit(token) {
      this.$v.$touch();
      if (this.$refs.form.validate()) {
        let startup = {
          "Area": this.$sanitize(this.area.trim()),
          "Name": this.$sanitize(this.name.trim()),
          "Country": this.$sanitize(this.country.trim()),
          "Region / city": (this.$sanitize(this.country) === 'Italy') ? this.$sanitize(this.region.trim()) : this.$sanitize(this.city.trim()),
          "Contact name": this.$sanitize(this.contactName.trim()),
          "Contact details": this.$sanitize(this.contactDetails.trim()),
          "State of contact": "To be contacted",
          "Idea description-EN": this.$sanitize(this.englishDescription.trim()),
          "Idea description-IT": this.$sanitize(this.italianDescription.trim()),
          "Vertical solution (if any)": this.$sanitize(this.verticalSolution.trim()),
          "Idea state": this.$sanitize(this.ideaState.trim()),
          "Patent": this.convertParameter(this.patent),
          "SDK/API": this.convertParameter(this.sdk),
          "Existing Partnerships/Exclusivity (non-VC's)" : this.convertParameter(this.existing_partnership),
          "Business model": this.businessModel.trim(),
          "Website": (!this.website.startsWith("http") && this.website !== "") ? "http://" + this.website.trim() : this.website.trim(),
          "Tags": this.Tags,
          "Mobile phone": this.$sanitize(this.mobilePhone.trim()),
          "Contact links": (!this.contactLinks.startsWith("http") && this.contactLinks !== "") ? "http://" + this.contactLinks.trim() : this.contactLinks.trim(),
          "Contact address": this.$sanitize(this.contactAddress.trim()),
          "Fundings amount": this.$sanitize(this.fundingsAmount.trim()),
          "Logo": (!this.logo.startsWith("http") && this.logo !== "") ? "http://" + this.logo.trim() : this.logo.trim(),
          "Crunchbase link": (!this.crunchbaseLink.startsWith("http") && this.crunchbaseLink !== "") ? "http://" + this.crunchbaseLink.trim() : this.crunchbaseLink.trim(),
          "Fundings date": this.$sanitize(this.fundingsDate.trim()),
          "Fundings investors": this.$sanitize(this.fundingsInvestors.trim()),
          "Valuation": this.$sanitize(this.Valuation.trim()),
          "Competitors": this.$sanitize(this.Competitors.trim()),
          "Foundation":this.$sanitize(this.foundation.trim()),
          "NumberEmployees": this.$sanitize(this.numberEmployees.trim()),
          "UrlVideo": (!this.urlVideo.startsWith("http") && this.urlVideo !== "") ? "http://" + this.urlVideo.trim() : this.urlVideo.trim()
        };
        for (let key in startup) {
          if (startup[key] === '') {
            startup[key] = null;
          }
        }
        let requestUrl = {
          url: UrlsService.registerStartupPublic,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          startup: startup,
          captchaResponse: token
        };
        let requestObject = {
          type: "public",
          urlsInfo: requestUrl,
          data: {
            data: requestData
          },
        };
        let messages = {
          title: "Register startup",
          loading: "Registering",
          error: "Server Error",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {
              //let response = responseSuccess;
              this.registrationStatus = true;
              //if(response.response !== undefined && response.responseStatus !== undefined && response.responseStatus.code === 200){
              if (responseSuccess === "OK") {
                this.registrationError = false;
                this.clear();
              } else {
                this.registrationError = true;
              }
            })
      }

    },
    convertParameter(param) {
      param = param.toLowerCase()
      if (param === "yes") return "y";
      else if (param === "no") return "n";
      else if (param === "pending") return "pending";
      else return "-";
    },
    inverseConvertParameter(param) {
      param = param.toLowerCase()
      if (param === "y") return "Yes";
      else if (param === "n") return "No";
      else if (param === 'pending') return "Pending";
      else return "";
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.country = "";
      this.region = "";
      this.city = "";
      this.contactName = "";
      this.contactDetails = "";
      this.verticalSolution = "";
      this.area = "";
      this.ideaState = "";
      this.patent = "";
      this.sdk = "";
      this.existing_partnership = "";
      this.businessModel = "";
      this.website = "";
      this.mobilePhone = "";
      this.contactLinks = "";
      this.contactAddress = "";
      this.fundingsAmount = "0.0"
      this.logo = "";
      this.crunchbaseLink = "";
      this.fundingsDate = "";
      this.fundingsInvestors = "";
      this.foundation = "";
      this.numberEmployees = "";
      this.urlVideo = "";
      this.Tags = [];
    },
    returnFields() {
      let startup = {
        "Area": this.area,
        "Name": this.name,
        "Country": this.country,
        "Region / city": this.country === 'Italy' ? this.region : this.city,
        "Contact name": this.contactName,
        "Contact details": this.contactDetails,
        "State of contact": "To be contacted",
        "Idea description-EN": this.englishDescription,
        "Idea description-IT": this.italianDescription,
        "Vertical solution (if any)": this.verticalSolution,
        "Idea state": this.ideaState,
        "Patent": this.convertParameter(this.patent),
        "SDK/API": this.convertParameter(this.sdk),
        "Existing Partnerships/Exclusivity (non-VC's)": this.convertParameter(this.existing_partnership),
        "Business model": this.businessModel,
        "Website": (!this.website.startsWith("http") && this.website !== "") ? "http://" + this.website : this.website,
        "Tags": this.Tags,
        "Mobile phone": this.mobilePhone,
        "Contact links": (!this.contactLinks.startsWith("http") && this.contactLinks !== "") ? "http://" + this.contactLinks : this.contactLinks,
        "Contact address": this.contactAddress,
        "Fundings amount": this.fundingsAmount,
        "Logo": (!this.logo.startsWith("http") && this.logo !== "") ? "http://" + this.logo : this.logo,
        "Crunchbase link": (!this.crunchbaseLink.startsWith("http") && this.crunchbaseLink !== "") ? "http://" + this.crunchbaseLink : this.crunchbaseLink,
        "Fundings date": this.fundingsDate,
        "Fundings investors": this.fundingsInvestors,
        "Valuation": this.Valuation,
        "Competitors": this.Competitors,
        "Foundation": this.foundation,
        "NumberEmployees": this.numberEmployees,
        "UrlVideo": (!this.urlVideo.startsWith("http") && this.urlVideo !== "") ? "http://" + this.urlVideo : this.urlVideo,
        "approved": 0
      };
      return startup;
    }
  },
};
</script>

<style lang="scss">
.text_wrapper {
  overflow-x: hidden;
}
</style>

